<div class="animated fadeIn container-fluid" [formGroup]="form">
    <h4>{{ title }} Tipo de Documentación para Campañas</h4>

    <div class="row">
        <div class="col-md-12">
            
            <div class="row">

                <div class="col-md-12">
                    <div class="card card-accent-success animated fadeIn">
                        <a class="card-header-a" (click)="isCollapsedCabecera = !isCollapsedCabecera" [attr.aria-expanded]="!isCollapsedCabecera" aria-controls="collapseExample">
                            <div class="card-header-buscador">
                                <i class="fa fa-file-text-o"></i> Datos del Tipo de Documentación para Campañas
                                <i *ngIf="isCollapsedCabecera" class="fa fa-caret-down float-right"></i>
                                <i *ngIf="!isCollapsedCabecera" class="fa fa-caret-up float-right"></i>
                            </div>
                        </a>
                        <div class="card-body-detalle">
                            <div class="collapse group-filtros" id="collapsedCabecera" [ngbCollapse]="isCollapsedCabecera">

                                <div class="row">


                                    <div class="form-group col-md-4">
                                        <label class="col-form-label required-field" for="intDescripcion">Descripción</label>
                                        <input formControlName="Descripcion" name="Descripcion" class="form-control" inputStyleClass="form-control" [ngClass]="displayFieldCss('Descripcion')" type="text" value="">
                                        <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('Descripcion','required')">
                                            La Descripción es obligatoria
                                        </div>
                                        </div>

                                    <div class="form-group col-md-4">
                                        <label class="col-form-label required-field" for="inpOrden">Orden</label>
                                        <input formControlName="Orden" name="Orden" class="form-control" inputStyleClass="form-control" [ngClass]="displayFieldCss('Orden')" type="number" value="">
                                        <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('Orden','required')">
                                            El Orden es obligatorio
                                        </div>
                                        <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('Orden','min')">
                                            El Orden no puede ser inferior a 0
                                        </div>
                                    </div>

                                    <div class="form-group col-md-4">
                                        <label class="col-form-label required-field" for="inpActivo">Activo</label>
                                        <p-toggleButton class="form-control-togglebutton" formControlName="Activo" onLabel="Sí" offLabel="NO" onIcon="pi pi-check" offIcon="pi pi-times"></p-toggleButton>
                                        <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('Activo','required')">
                                            Indicar si está Activo es obligatorio
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>

</div>
